<li>
    <span class="tree_label">
        <slot />
    </span>
</li>

<style>
    li {
        line-height: 1.2;
        position: relative;
        padding: 0 0 1em 1em;
    }

    .tree_label {
        position: relative;
        display: inline-block;
    }

</style>
